import React, { useState, useEffect, useRef } from "react";
import { useHistory, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { logout } from "../../redux/actions/userAction";
import { tokenValidation, tokenPayload } from "../../redux/actions/userAction";
import { SetRole } from "../../redux/actions/userAction";
import { chatLeave } from "../../redux/actions/roomAction";
import { roomJoin } from "../../redux/actions/roomAction";

import MatchSetting from "./matchSetting/matchSetting";
import RoomCategory from "./RoomCategory/roomCategory";
import Playlist from "./Playlist/playlist";

import "./origin.css";

const Origin = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const userState = useSelector(state => state.user); // { isLoading, data: { validToken, user: { id, username, email } }, err }

	// Checking if there is a previous client
	useEffect(() => {
		console.log("myDate.toDateString()", new Date().toDateString());

		// validate the token and get user data if the token is valid
		if (!userState.id) dispatch(tokenPayload());
		else dispatch(tokenValidation()); // validate the token
	}, [window.location.origin]);

	const [isRoomJoin, setIsRoomJoin] = useState(true); // PV: true, false
	const [roomCategoryVisible, setRoomCategoryVisible] = useState(false); // PV: true, false
	const [matchSettingVisible, setMatchSettingVisible] = useState(false); // PV: true, false

	return (
		<div className="origin-page">
			<Playlist />
			<input
				type="submit"
				className="logout-btn"
				value={userState.validToken ? "LOGOUT" : "LOGIN"}
				onClick={() => (userState.validToken ? dispatch(logout()) && history.push("/login") : history.push("/login"))}
			/>

			<RoomCategory
				roomCategoryVisible={roomCategoryVisible}
				setIsRoomJoin={setIsRoomJoin}
				setMatchSettingVisible={setMatchSettingVisible}
				setRoomCategoryVisible={setRoomCategoryVisible}
			/>
			<MatchSetting
				matchSettingVisible={matchSettingVisible}
				isRoomJoin={isRoomJoin}
				setMatchSettingVisible={setMatchSettingVisible}
				setRoomCategoryVisible={setRoomCategoryVisible}
			/>

			<div className="holderTop"></div>
			<div className="menu-container">
				<input type="submit" className="menu-selection-main btn-main" value="PLAY" onClick={() => setRoomCategoryVisible(true)} />
				<input type="submit" className="menu-selection-main btn-main" value="WATCH" onClick={() => history.push("/watch")} />
				<input type="submit" className="menu-selection-main btn-main" value="RANK" onClick={() => history.push("/rank")} />

				<div className="menu-selection-sub">
					<input type="submit" value="RULES" className="btn-sub" onClick={() => history.push("/rules")} />
					<a href="https://jawod50.github.io/OfficialWebsite/" target="new">
						<input type="submit" value="MORE" className="btn-sub" onClick={() => console.log("MORE")} />
					</a>
				</div>
			</div>
		</div>
	);
};

export default Origin;
